import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { axiosClient } from './axiosClient';
import { Admin } from 'types/Admin';

const resource = '';

const admin = {
  GetAdminSettings() {
    const [dataEnvironment] = useDataEnvironment();
    return useQuery(
      ['admin-settings', dataEnvironment?.id],
      () =>
        axiosClient.get<Admin>(
          `${resource}/${dataEnvironment?.id}/admin_settings`
        ),
      {
        select: (data) => data?.data,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: 'always',
      }
    );
  },
  UpdateAdminSettings() {
    const [dataEnvironment] = useDataEnvironment();
    const queryClient = useQueryClient();
    return useMutation(
      ['admin-settings-update', dataEnvironment?.id],
      (body: { valueTypeId: number; defaultLagDate: string | null }) => {
        return axiosClient.put<Admin>(
          `${resource}/${dataEnvironment?.id}/admin_settings`,
          { ...body }
        );
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([
            'admin-settings',
            dataEnvironment?.id,
          ]);
        },
      }
    );
  },
};

export default admin;
